import { render, staticRenderFns } from "./addwarehouseallocation.vue?vue&type=template&id=f37e95d2&scoped=true&"
import script from "./addwarehouseallocation.vue?vue&type=script&lang=js&"
export * from "./addwarehouseallocation.vue?vue&type=script&lang=js&"
import style0 from "./addwarehouseallocation.vue?vue&type=style&index=0&id=f37e95d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37e95d2",
  null
  
)

export default component.exports